import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import AuthModal from './Modals/AuthModal'

export default function (ComposedComponent) {
	
	class Authentication extends React.Component {
		
		/** AUTH MODAL **/
		constructor(props) {
			super(props);
			this.state = {
				modal: false,
				defaultAuth: true,
				authReq: false
			};
			this.onClose = this.onClose.bind(this);
			this.onOverlay = this.onOverlay.bind(this);
		}

		onClose() {
			document.body.classList.remove('modal-open');
			this.setState({
				modal: false,
				authReq: false
			});
			if (!this.props.authenticated) {
				this.props.history.push("/")
			}
		}
		
		onOverlay(e) {
			if (e.target.dataset.modal) {
				this.onClose();
			}
		}
		/** END AUTH MODAL **/
		
		componentWillMount() {
			if (!this.props.authenticated) {
				this.setState({
					modal: true,
					authReq: true
				})
			}
		}
	
		componentWillUpdate(nextProps) {
			if (!this.props.authenticated) {
				this.setState({
					modal: true,
					authReq: true
				})
			}
		}
	
		render() {
			if (this.state.authReq) {
				return <AuthModal onOverlay={ this.onOverlay } onClose={ this.onClose } isOpen={ this.state.modal } defaultAuth={ this.state.defaultAuth } transitionName="opacity" />
			}
			return <ComposedComponent {...this.props} />
		}
	}
	
	function mapStateToProps(state) {
		return {
			authenticated: state.auth.authenticated
		}
	}
	
	return withRouter(connect(mapStateToProps)(Authentication))
}


// WEBPACK FOOTER //
// ./src/components/Require_Auth.js